/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Header_Search_Placeholder1Inputs */

const vi_sitesettings_header_search_placeholder1 = /** @type {(inputs: Sitesettings_Header_Search_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gợi ý trong ô tìm kiếm (máy tính)`)
};

/**

* @param {Sitesettings_Header_Search_Placeholder1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_header_search_placeholder1 = /** @type {((inputs?: Sitesettings_Header_Search_Placeholder1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Header_Search_Placeholder1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_header_search_placeholder1(inputs)
});
export { sitesettings_header_search_placeholder1 as "siteSettings_header_search_placeholder" }